export function Thoranam() {
  return <div className="thoranam" aria-hidden="true" />;
}

export function Grain() {
  return (
    <>
      <div className="grain" aria-hidden="true" />
      <div className="vignette" aria-hidden="true" />
    </>
  );
}
